/**
 * Mathematical utility functions.
 */
class MathUtil
{


    /**
     * Return integer between min and max
     * @public
     * @param min
     * @param max
     * @returns {*}
     */
    static getRandomInt(min, max)
    {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }


    static getRandomIntExclude(min, max, exclude)
    {
        let num = this.getRandomInt(min, max);
        if (num == exclude)
        {
            let a = (num > max/2) ? -1 : 1;
            num += a;
        }

        return num;
    }


    static getRandomFloat(min, max)
    {
        return Math.random() * (max - min) + min;
    }


    /**
     * Returns minVal if value < minVal , maxVal if value > maxVal, unchanged value otherwise
     * @public
     * @param value
     * @param minVal
     * @param maxVal
     * @returns {number}
     */
    static clamp(value, minVal, maxVal)
    {
        return (Math.max(minVal, Math.min(value, maxVal)));
    }


    /**
     * Calculates the mean value of an array of numbers
     * @public
     * @param a {Array} - array of numbers
     * @returns {number}
     */
    static average(a)
    {
        let sum = 0;
        for (let i = 0; i < a.length; i++)
        {
            sum += a[i];
        }
        return sum/a.length;
    }


    static getRndSign()
    {
        return Math.random() > .5 ? -1 : 1;
    }


    static polarToRectangular(r, theta)
    {
        return new PIXI.Point(r * Math.cos(theta), r * Math.sin(theta));
    }


}

export default MathUtil